import script from "./BaixaTituloFinanceiro.vue?vue&type=script&setup=true&lang=js"
export * from "./BaixaTituloFinanceiro.vue?vue&type=script&setup=true&lang=js"

import "./BaixaTituloFinanceiro.vue?vue&type=style&index=0&id=19b98f83&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b98f83"]])

export default __exports__